import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

const otColors = {
	primary: "#2F66F1"
};

const otPrimary = {
	50: "#DCE5FD",
	100: "#BACCFA",
	200: "#97B3F8",
	300: "#7499F6",
	400: "#5280F3",
	500: "#2F66F1",
	600: "#2755C9",
	700: "#1F44A1",
	800: "#183379",
	900: "#102250",
	950: "#081128"
};

export const onetagPreset = definePreset(Aura, {
	semantic: {
		primary: otPrimary
	},
	components: {
		button: {
			root: {
				borderRadius: "8px"
			}
		},
		accordion: {
			header: {
				color: otColors.primary,
				activeColor: otColors.primary
			},
			panel: {
				borderColor: otColors.primary
			}
		}
	}
});
